import './PrerequisiteBadge.css';
import React from 'react';

export const NoPrerequisiteBadge = () => {
    return <span className="prerequisitebadge prerequisitebadge--none">NONE</span>;
};
